export type EdgeInsets = { left: number; top: number; right: number; bottom: number }

export type CalculatorTapeSize = 'sm' | 'md'

export type CalculatorTapeLayout = {
  container: {
    width: number
    padding: EdgeInsets
  }
  title: {
    height: number
    fontSize: number
  }
  row: {
    height: number
    fontSize: number
  }
  column: {
    gap: number
    leftFlex: number
    rightFlex: number
  }
  dividerHeight: number
  editor: {
    controls: {
      gap: number
      padding: EdgeInsets
    }
    input: {
      height: number
      fontSize: number
      paddingX: number
    }
    keypad: {
      gap: number
      buttonHeight: number
      buttonFontSize: number
      buttonPaddingX: number
    }
  }
}

const CALCULATOR_TAPE_LAYOUTS: Record<CalculatorTapeSize, CalculatorTapeLayout> = {
  sm: {
    container: {
      width: 98,
      padding: { left: 10, top: 10, right: 10, bottom: 10 }
    },
    title: {
      height: 10,
      fontSize: 7
    },
    row: {
      height: 10,
      fontSize: 6
    },
    column: {
      gap: 2,
      leftFlex: 2,
      rightFlex: 1
    },
    dividerHeight: 7,
    editor: {
      controls: {
        gap: 3,
        padding: { left: 6, top: 3, right: 6, bottom: 6 }
      },
      input: {
        height: 14,
        fontSize: 6,
        paddingX: 6
      },
      keypad: {
        gap: 1,
        buttonHeight: 16,
        buttonFontSize: 8,
        buttonPaddingX: 4
      }
    }
  },
  md: {
    container: {
      width: 140,
      padding: { left: 14, top: 14, right: 14, bottom: 14 }
    },
    title: {
      height: 14,
      fontSize: 10
    },
    row: {
      height: 14,
      fontSize: 8
    },
    column: {
      gap: 2,
      leftFlex: 2,
      rightFlex: 1
    },
    dividerHeight: 10,
    editor: {
      controls: {
        gap: 4,
        padding: { left: 8, top: 4, right: 8, bottom: 8 }
      },
      input: {
        height: 20,
        fontSize: 8,
        paddingX: 8
      },
      keypad: {
        gap: 1,
        buttonHeight: 28,
        buttonFontSize: 14,
        buttonPaddingX: 8
      }
    }
  }
}

export function getCalculatorTapeLayout(target: {
  size: CalculatorTapeSize
}): CalculatorTapeLayout {
  return CALCULATOR_TAPE_LAYOUTS[target.size]
}
